<wd-simple-layout label="Bohrpunktliste">
	<div list-element class="left-split">
		<bp-bohrpunkt-list-panel
			[bps]="bps"
			[pointsFilter]="pointsFilter"
			[boundsFilter]="boundsFilter"
			[currentBounds]="currentBounds"
			[showProjectPointsFilter]="true"
			(pointSelected)="select($event.bp)"
			(pointsDeleted)="initPoints()"
			(filterApplied)="onFilterApplied($event)"
			(settingsChanged)="onListSettingsChanged()">
		</bp-bohrpunkt-list-panel>
	</div>
	<div content-element class="col h-100">
		@if (mapStatusService.globalMapState() | async; as globalMapState) {
			<bp-map [visible]="true" [online]="!oms.offlineMode()" [mapStatus]="globalMapState" [persistentBounds]="true"
				[points]="mapMarkers" [pointsFilter]="pointsFilter" [layers]="ls.mapDef().layers"
				(pointDeleted)="onPointDeleted($event)">
			</bp-map>
		}
	</div>
</wd-simple-layout>
